import { FEATURE_FLAGS } from '../../../../featureFlags';
import Bot from './Index.vue';
import ConfigurationAssistant from './ConfigurationAssistant.vue';
import Usage from './Usage.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const meta = {
  permissions: ['administrator'],
  featureFlag: FEATURE_FLAGS.AGENT_BOTS,
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ai'),
      meta,
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'ai_configuration_assistant',
            params: to.params,
          }),
        },
        {
          path: 'configuration',
          alias: frontendURL(
            'accounts/:accountId/settings/agent-bots/configuration-assistant'
          ),
          name: 'ai_configuration_assistant',
          component: ConfigurationAssistant,
          meta,
        },
        {
          path: 'usage',
          name: 'ai_usage',
          component: Usage,
          meta,
        },
        {
          path: 'advanced',
          alias: frontendURL('accounts/:accountId/settings/agent-bots'),
          name: 'agent_bots',
          component: Bot,
          meta,
        },
      ],
    },
  ],
};
